import { gql } from '@apollo/client/core';
import { useMutation } from '@vue/apollo-composable';
import { sendPasswordResetMail } from '@spectee/graphql/mutations';

const document = gql(sendPasswordResetMail);

export function useSendPasswordResetMail() {
  return useMutation(document);
}
